const styles = {
  footer: {
    fontSize: 14,
    textAlign: "center",
    marginBlock: "3%",
    marginTop:'15px',
    color: "#707070",
  },
};

export default styles;
